import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CircularProgress from 'material-ui/CircularProgress';

import { getVessels } from 'actions/vessels/vessels';
import styles from 'styles';

import VesselListTable from './Table';

function VesselListPage(props) {
    const { isLoaded, vessels, getVessels } = props;

    useEffect(() => {
        getVessels({
            page: vessels.page,
            limit: vessels.limit,
            notConfirmed: vessels.notConfirmed,
            sanctioned: vessels.sanctioned,
            isNameSuggestion: vessels.isNameSuggestion,
        });
    }, []);

    return (
        <div id='vessel-list' className='table-page'>
            <CircularProgress className={!isLoaded ? '' : 'hidden'} style={styles.circularProgress} />

            <div className={isLoaded ? '' : 'hidden'}>
                <div className='container-fluid'>
                    <h2>
						Vessels
                    </h2>
                    <VesselListTable />
                </div>
            </div>
        </div>
    );
}

export default connect(
    ({ user: { isLogged }, vessels }) => ({
        isLogged,
        vessels,
        isLoaded: vessels.isLoaded,
    }),
    dispatch => bindActionCreators(
        {
            getVessels,
        },
        dispatch,
    ),
)(VesselListPage);



// WEBPACK FOOTER //
// ./app/components/Vessels/List/Page.jsx